import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { modelOf } from '../../../prop-types';
import AdStore from '../../../store/AdStore';
import ConfigStore from '../../../store/ConfigStore';
import AdZones from '../../../types/AdZones';
import BannerSlider from '../BannerSlider/BannerSliderSlides';

// Figma 1440 x 120
const ASPECT_RATIO = 12;

const CheckoutHeaderBanner = ({ adStore, configStore, className }) => {
  const ads = adStore.getGlobalAdsByAdZone(AdZones.CHECKOUT_HEADER_BANNER);

  if (!ads || ads.length === 0) {
    return null;
  }

  const bannerSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <BannerSlider
      adZone={AdZones.CHECKOUT_HEADER_BANNER}
      searchParams={{}}
      className={classNames('CheckoutHeaderBanner', className)}
      aspectRatio={ASPECT_RATIO}
      maximumCrossAxisSize={configStore.banner.checkout.headerHeight}
      overrideSettings={bannerSettings}
      preLoadedAds={ads}
    />
  );
};

CheckoutHeaderBanner.propTypes = {
  adStore: modelOf(AdStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  className: PropTypes.string,
};

export default inject('adStore', 'configStore')(observer(CheckoutHeaderBanner));
